import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var ChatBubble = function ChatBubble(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58789 22.4668C5.7793 22.4668 8.62109 21.2266 10.3984 19.9766C10.584 19.8398 10.7402 19.791 10.8965 19.791C11.0234 19.8008 11.1406 19.8105 11.248 19.8105C18.2891 19.8008 23.3281 15.9629 23.3281 10.6895C23.3281 5.64062 18.2793 1.57812 11.9902 1.57812C5.70117 1.57812 0.662109 5.64062 0.662109 10.6895C0.662109 13.834 2.55664 16.6465 5.75977 18.375C5.93555 18.4824 5.98438 18.6289 5.89648 18.8047C5.33008 19.752 4.38281 20.8066 3.99219 21.3047C3.55273 21.8613 3.80664 22.4668 4.58789 22.4668Z"
  })));
};

ChatBubble.displayName = 'ChatBubble';
export default ChatBubble;